<template>
	<div class="main" v-if="loaded">
		<header class="page-title">
			<h2>{{ provider.name }} &ndash; Change Requests</h2>
		</header>

		<div class="table-reponsive">
			<table>
				<thead>
					<tr>
						<th>Date</th>
						<th>Requested by</th>
						<th>Property Name</th>
						<th>Our Current Value</th>
						<th>Proposed Value</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr :key="cr.request_id" v-for="cr in changeRequests">
						<td>{{ cr.date }}</td>
						<td>{{ cr.requested_by }}</td>
						<td>{{ cr.property_name }}</td>

						<td v-if="cr.property_value === null">N/A</td>
						<td v-else-if="cr.property_type === 'checkbox'">{{ cr.property_value === '0' ? 'False' : 'True' }}
						</td>
						<td v-else>{{ cr.property_value }}</td>

						<td v-if="cr.property_type === 'checkbox'">{{ cr.requested_value === '0' ? 'False' : 'True' }}</td>
						<td v-else>{{ cr.requested_value }}</td>

						<td>
							<a :disabled="lockButtons" @click="approve(cr)" class="btn btn-icon btn-success"><i
									class="fas fa-fw fa-check"></i></a>
							<a :disabled="lockButtons" @click="reject(cr)" class="btn btn-icon btn-danger"><i
									class="fas fa-fw fa-times"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="modal-bg" v-if="selectedRequest !== null && selectedRequest.translations !== undefined"
			 v-show="approveModal">
			<div class="modal">
				<header class="modal-header">
					<h4 class="modal-title">Please confirm approval</h4>
					<a @click.prevent="cancelApprove" class="modal-close" title="Close modal"><i
							class="fas fa-times"></i></a>
				</header>
				<section class="modal-body">
					<p>
						<strong>Recommended text:</strong> {{ translateValue }}
						<a @click="copyValue()" class="btn btn-sm btn-default"
						   title="Copy value to current translation"><i class="fas fa-fw fa-clipboard"></i></a>
					</p>
					<div class="card">
						<header class="card-header language-list">
							<lang-selector></lang-selector>
						</header>
						<div class="card-body">
							<div :key="reRenderKey" class="form-group">
								<label for="trans">Translation</label>
								<input id="trans" type="text" v-model="selectedRequest.translations[clickedLang].value">
							</div>
						</div>
					</div>
					<div class="form-group">
						<label for="numeric-value">Normalized value<sup class="text-danger">*</sup></label>
						<input class="input-small" id="numeric-value" required="required" step=".01" type="number"
							   v-model="selectedRequest.numericValue">
					</div>

				</section>
				<footer class="modal-footer">
					<a :disabled="lockButtons" @click.prevent="cancelApprove" class="btn btn-md btn-primary">
						<i class="fas fa-fw fa-times"></i> Cancel
					</a>
					<a :disabled="lockButtons" @click.prevent="saveApprove" class="btn btn-md btn-success" href="#">
						<i class="fas fa-fw fa-save"></i>Approve Change
					</a>
				</footer>
			</div>
		</div>

		<div class="modal-bg" v-if="selectedRequest !== null" v-show="rejectModal">
			<div class="modal">
				<header class="modal-header">
					<h4 class="modal-title">Please provide reason for declining</h4>
					<a @click.prevent="cancelReject" class="modal-close" title="Close modal"><i
							class="fas fa-times"></i></a>
				</header>
				<section class="modal-body">
					<p v-if="selectedRequest.property_type === 'text'"><strong>Recommended text:</strong> {{
						translateValue }}</p>
					<p v-else-if="selectedRequest.property_type === 'checkbox'"><strong>Recommended value:</strong> {{
						translateValue === '1' ? 'True' : 'False' }}</p>
					<p v-else><strong>Recommended value:</strong> {{ translateValue }}</p>

					<div class="form-group">
						<label for="reject-reason">Reason for declining<sup class="text-danger">*</sup></label>
						<textarea class="input-small" id="reject-reason" required="required"
								  v-model="selectedRequest.rejectReason"></textarea>
					</div>

				</section>
				<footer class="modal-footer">
					<a :disabled="lockButtons" @click.prevent="cancelReject" class="btn btn-md btn-primary">
						<i class="fas fa-fw fa-times"></i> Cancel
					</a>
					<a :disabled="lockButtons" @click.prevent="saveReject" class="btn btn-md btn-danger" href="#">
						<i class="fas fa-fw fa-save"></i>Decline Request
					</a>
				</footer>
			</div>
		</div>

	</div>
</template>

<script>
	import {eventBus} from '../../app';

	export default {
		props: {
			providerid: {
				type: Number
			}
		},
		data() {
			return {
				loaded: false,
				tabName: 'providerChangeRequests',
				provider: {},
				changeRequests: {},
				providerId: this.providerid,
				userRoles: this.$currentUserRoles,

				selectedRequest: null,

				clickedLang: this.$defaultLanguage.locale,
				approveModal: false,
				translateValue: '',

				rejectModal: false,

				lockButtons: false,
				reRenderKey: 0
			}
		},
		created() {
			this.fetchDataFromApi();
			const vm = this;
			eventBus.$on('setActiveStatus', function (targetLang) {
				vm.clickedLang = targetLang;
			});
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/fetchtabdata/' + vm.providerId, {
					tab: vm.tabName
				})
					.then(response => {
						if (response.data.hasOwnProperty('provider')) {
							vm.provider = response.data.provider;
						}
						if (response.data.hasOwnProperty('changeRequests')) {
							vm.changeRequests = response.data.changeRequests;
						}
						vm.loaded = true;
					})
					.catch(e => {
						vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
					});
			},
			approve: function (request) {
				if (this.lockButtons) return;
				this.selectedRequest = request;

				if (request.numericValue === undefined) {
					request.numericValue = null;
				}

				if (request.property_type === 'text') {

					if (request.translations === undefined) {
						request.translations = {};
						for (let i = 0; i < this.$availableLanguages.length; i++) {
							request.translations[this.$availableLanguages[i].locale] = {value: ''}
						}
					}

					return this.openApproveModal();
				}
				this.doApprove(request.request_id, request.requested_value);
			},
			reject: function (request) {
				if (this.lockButtons) return;
				this.selectedRequest = request;
				if (request.rejectReason === undefined) {
					request.rejectReason = '';
				}
				this.openRejectModal()
			},

			openApproveModal: function () {
				this.translateValue = this.selectedRequest.requested_value;
				this.translatedValue = '';
				this.numericValue = null;
				this.approveModal = true;
			},
			saveApprove: function () {
				if (this.lockButtons) return;
				this.doApprove(
					this.selectedRequest.request_id,
					this.selectedRequest.numericValue,
					this.selectedRequest.translations
				);
			},
			cancelApprove: function () {
				if (this.lockButtons) return;
				this.approveModal = false;
			},
			doApprove: function (requestId, value, translations = {}) {
				const vm = this;

				const data = {
					value: value,
					translations: {}
				};

				for (const idx in Object.keys(translations)) {
					const lang = Object.keys(translations)[idx];
					const item = translations[lang];
					if (item.value !== undefined && item.value !== null && item.value !== '') {
						data.translations[lang] = item;
					}
				}

				this.lockButtons = true;
				axios.post('/api/' + vm.$selectedSite.slug + '/portal-request/' + requestId + '/approve', data)
					.then(response => {
						vm.$toastr.success('Approval saved successfully', 'Success');
						this.lockButtons = false;
						this.approveModal = false;
						this.removeSelectedRequest();
					})
					.catch(e => {
						this.$toastr.error('Approval save failed.', 'Error');
						this.lockButtons = false;
					});
			},

			openRejectModal: function () {
				this.translateValue = this.selectedRequest.requested_value;
				this.rejectReason = '';
				this.rejectModal = true;
			},
			saveReject: function () {
				if (this.lockButtons) return;
				const vm = this;
				const requestId = this.selectedRequest.request_id;
				const data = {
					reason: this.selectedRequest.rejectReason
				};
				this.lockButtons = true;
				axios.post('/api/' + vm.$selectedSite.slug + '/portal-request/' + requestId + '/reject', data)
					.then(response => {
						vm.$toastr.success('Reject saved successfully', 'Success');
						this.lockButtons = false;
						this.rejectModal = false;
						this.removeSelectedRequest();
					})
					.catch(e => {
						this.$toastr.error('Reject save failed.', 'Error');
						this.lockButtons = false;
					});
				this.rejectModal = false;
			},
			cancelReject: function () {
				if (this.lockButtons) return;
				this.rejectModal = false;
			},

			copyValue: function () {
				this.selectedRequest.translations[this.clickedLang].value = this.translateValue;
				this.reRenderKey += 1;
			},

			removeSelectedRequest: function () {
				const request = this.selectedRequest;
				this.selectedRequest = null;
				this.changeRequests.splice(this.changeRequests.indexOf(request), 1);
			}

		}
	}
</script>

<style scoped>

</style>
